import { Component, Input, OnDestroy, OnInit, ViewChild, ViewChildren, QueryList, inject } from '@angular/core';
import { TableUserSettingsComponent } from 'app/ui/table-user-settings/table-user-settings.component';
import { TranslateService } from '@ngx-translate/core';
import { EntityListComponent } from 'app/components/entity-list/entity-list.component';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { InvVehicleService } from 'app/modules/vehicle-inventory/services/invVehicle.service';
import { Rest } from 'app/rest/rest_client';
import { I18nService } from 'app/services/i18n/i18n.service';
import { LoadingService } from 'app/services/loading-service/loading.service';
import { NotificationsService } from 'app/services/notifications-service/notifications.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ExcelService } from "app/services/excel-service/excel.service";
import { VehiclebrandService } from 'app/rest/vehiclebrand.service';
import { Subscription } from 'rxjs';
import { DelegationService } from 'app/modules/vehicle-inventory/services/table-management/delegation.service';
import { SubdelegationService } from 'app/rest/subdelegation.service';
import { DriverService } from 'app/modules/vehicle-inventory/services/driver.service';
import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { CecoService } from 'app/rest/ceco.service';
import { throwIfEmpty } from 'rxjs/operators';
import { FinanceTypeService } from 'app/modules/vehicle-inventory/services/table-management/financing_type.service';
import { runInThisContext } from 'vm';
import { ColumnFilter} from 'primeng/table';
import { TaskUseful } from 'app/modules/task/shared/task_useful';
import { PrimeNG } from 'primeng/config';

// import { NumericValuePipe } from 'app/numeric-value.pipe';

@Component({
    selector: 'app-inventory-vehicles-table',
    templateUrl: './inventory-vehicles-table.component.html',
    styleUrls: ['./inventory-vehicles-table.component.css'],
    providers: [CecoService, FinanceTypeService],
    standalone: false
})
export class InventoryVehiclesTableComponent extends EntityListComponent<Rest.Vehicle> implements OnInit, OnDestroy {
	@ViewChildren(ColumnFilter) columnFilters: QueryList<ColumnFilter>;
	@ViewChild(TableUserSettingsComponent) tableSettingsComp: TableUserSettingsComponent;
	@Input() driver?: Rest.InvDriver = null;
	@Input() startDate?: Date = null;
	@Input() endDate?: Date = null;
	@Input() nested?: Boolean = false;

	user: Rest.User;
	EnabledFilter: SelectItem[];

	/** Params **/
	isNew: boolean = false;
	selectedVehicle: Rest.Vehicle;
	firstLoad: boolean = true;

	/** Vehicle Inventory GET_PAGE FILTERS **/
	selectedClient: number = 0; //394971; <--CIRSA

	brandList: Rest.VehicleBrand[] = [];
	modelList: Rest.VehicleModel[] = [];
	versionList: Rest.VehicleVersion[] = [];
	vehicleTypeList: Rest.VehicleType[] = [];
	vehicleStatusList: Rest.VehicleStatus[] = [];
	companiesList: Rest.BillingAccount[] = [];
	delegationList: Rest.Delegation[] = [];
	subdelegationList: Rest.Subdelegation[] = [];
	updateListSubscription: Subscription;
	driversList: Rest.InvDriver[] = [];
	cecoList: Rest.Ceco[] = [];
	financingTypeList: any = [];
	vehicleTableFilters: any = {};
	columnsCount: number;
	// PERMISSIONS
	isCreateGranted: boolean = false;
	isFormGranted: boolean = false;
	isVehicleStateGranted: boolean = false;
	isCostGranted: boolean = false;
	isExtraGranted: boolean = false;

	startDateCreated: Date;
	endDateCreated: Date;
	startDateDisabled: Date;
	endDateDisabled: Date;
	startFinancingCancellationDate: Date;
	endFinancingCancellationDate: Date;
	startFinancingStartDate: Date;
	endFinancingStartDate: Date;
	startFinancingEndDate: Date;
	endFinancingEndDate: Date;
	startMonthlyFee: number;
	endMonthlyFee: number;
	startImportService: number;
	endImportService: number;
	startImportFinancing: number;
	endImportFinancing: number;
	startTotalImport: number;
	endTotalImport: number;
	numColumns: number = 24;
    optionsenabled: any[];
    filteredColumns: Array<{ field: string; valueid: string; value: string;fieldtrans:string }> = []; // Columnas filtradas

	combos:{ field: string; values: any[]; }[] = [];
	private config = inject(PrimeNG);
	constructor(
		private invVehicleService: InvVehicleService,
		protected confirmationService: ConfirmationService,
		protected notificationsService: NotificationsService,
		protected i18n: I18nService,
		protected authenticationService: AuthenticationService,
		protected loadingService: LoadingService,
		protected userTime: UserTimePipe,
		private translateService: TranslateService,
		protected excelService: ExcelService,
		protected vehiclebrandService: VehiclebrandService,
		protected vehiclemodelService: VehiclebrandService,
		protected vehicleversionService: VehiclebrandService,
		private delegationService: DelegationService,
		private subdelegationService: SubdelegationService,
		private driverService: DriverService,
		private datePipe: DatePipe,
		protected cecoService: CecoService,
		protected financingTypeService: FinanceTypeService
	) {
		super(
			invVehicleService,
			confirmationService,
			notificationsService,
			i18n,
			authenticationService,
			loadingService,
			userTime,
			excelService
		);
	}

	ngAfterViewInit(): void {
		super.ngAfterViewInit();
		this.savedOk.subscribe(() => this.tableSettingsComp?.hide());
	}

	get orderedVisibleFields(): string[] {
		return this._selectedColumns
			.filter((c: any) => c.field !== 'name')
			.map((c: any) => (c.field as string).replace(/\?\./g, '.'));
	}

	onColReorder(event: any): void {
		this.captureLiveWidths();
		const reorderable = this._selectedColumns.filter((c: any) => c.field !== 'name');
		const frozenCol = this._selectedColumns.find((c: any) => c.field === 'name');
		const moved = reorderable.splice(event.dragIndex, 1)[0];
		reorderable.splice(event.dropIndex, 0, moved);
		this._selectedColumns = frozenCol ? [frozenCol, ...reorderable] : reorderable;
		this.mapSelectedColumns();
		setTimeout(() => this.applyColumnWidths(), 0);
	}

	ngOnInit(): void {
		super.ngOnInit();
		//this.numericValue = this.NumericFormatPipe.
		this.selectedClient = this.authenticationService.user.client.id;

		//set inital filters
		this.vehicleTableFilters = {
			'enabled': [{ value: true }]
		}
		//this.paginationRequest.filters["enabled"] = ['true'];
		this.config.setTranslation({
			apply: this.translateService.instant('general.filters.apply'),
			clear: this.translateService.instant('general.filters.clear'),
		});

		this.updateListSubscription = this.invVehicleService.vehicleSaved
			.subscribe(
				() => {
					console.log("****** VEHICLE_TABLE_REFRESH **************");
					this.refresh();
				}
			);

		this.combos=[];
		this.getBrandsByClient(this.selectedClient);
		this.getModelsByClient(this.selectedClient);
		this.getVersionsByClient(this.selectedClient);
		this.getVehicleTypes();
		this.getVehicleStatus(this.selectedClient);
		this.getDrivers(this.selectedClient);
		this.getCompanies(this.selectedClient);
		this.getDelegationList(this.selectedClient);
		this.getCecoList();
		this.getFinancingTypeList();
		this.selectedClient = this.authenticationService.user.client.id;

		this.setPermissions();
		this.numColumns = this.isCostGranted ? 24 : 23;
		if (this.isExtraGranted) this.numColumns += 3;

		this.listId = 'inventory-vehicles';
		this.loadOptions();
		this.setColumns();
		this.initColumnVisibility();
		this.onFilterApplied();
	}
	loadOptions() {
        this.optionsenabled = [
          { label: this.translateService.instant('general.disabled'), value: false },
          { label: this.translateService.instant('general.active'), value: true }
        ];
      }

	ngOnDestroy(): void {
		this.updateListSubscription.unsubscribe();
	}
	extractNumericValue(value: string): number | null {
		const match = value.match(/\d+/); // Encuentra los números en el string
		return match ? parseInt(match[0], 10) : null; // Devuelve el número o null
	  }
	afterLoad() {
		this.paginationResult.entities.forEach((cl: any) => {
			console.log(cl);
			/*Permissions */
			cl._$changeStatus = true; //This is for the validation of entity-list (selectAll function)
			cl._$update = true;
			/** */
		});
		/*Permissions */
		this.checkSelectAll();

/*
		this.paginationResult.entities = this.paginationResult.entities.sort(
			(a, b) => a.name.localeCompare(b.name)
		);*/

	}

	protected beforeLoad() {
		this.paginationRequest.filters["client"] = [this.selectedClient.toString()];
		if (this.driver) this.paginationRequest.filters["driverId"] = [this.driver.id.toString()];
		if (this.startDateCreated) this.paginationRequest.filters["startDateCreated"] = [this.startDateCreated.toISOString()];
		 if (this.endDateCreated) this.paginationRequest.filters["endDateCreated"] = [this.endDateCreated.toISOString()];
		//if (this.startDateCreated) this.paginationRequest.filters["startDateCreated"] = [ TaskUseful.formatdateAPI(this.startDateCreated)];
		//if (this.endDateCreated) this.paginationRequest.filters["endDateCreated"] = [TaskUseful.formatdateAPI(this.endDateCreated)];
		if (this.startDateDisabled) this.paginationRequest.filters["startDateDisabled"] = [this.startDateDisabled.toISOString()];
		if (this.endDateDisabled) this.paginationRequest.filters["endDateDisabled"] = [this.endDateDisabled.toISOString()];
		if(this.startFinancingCancellationDate)this.paginationRequest.filters["startFinancingCancellationDate"] = [this.startFinancingCancellationDate.toISOString()];
		if(this.endFinancingCancellationDate)this.paginationRequest.filters["endFinancingCancellationDate"] = [this.endFinancingCancellationDate.toISOString()];
		if(this.startFinancingStartDate)this.paginationRequest.filters["startFinancingStartDate"] = [this.startFinancingStartDate.toISOString()];
		if(this.endFinancingStartDate)this.paginationRequest.filters["endFinancingStartDate"] = [this.endFinancingStartDate.toISOString()];
		if(this.startFinancingEndDate)this.paginationRequest.filters["startFinancingEndDate"] = [this.startFinancingEndDate.toISOString()];
		if(this.endFinancingEndDate)this.paginationRequest.filters["endFinancingEndDate"] = [this.endFinancingEndDate.toISOString()];
		if(this.startMonthlyFee)this.paginationRequest.filters["startFinancingMonthlyFee"] = [this.startMonthlyFee.toString()];
		if(this.endMonthlyFee)this.paginationRequest.filters["endFinancingMonthlyFee"] = [this.endMonthlyFee.toString()];
		if(this.startImportService)this.paginationRequest.filters["startFinancingImportService"] = [this.startImportService.toString()];
		if(this.endImportService)this.paginationRequest.filters["endFinancingImportService"] = [this.endImportService.toString()];
		if(this.startImportFinancing)this.paginationRequest.filters["startFinancingImportFinancing"] = [this.startImportFinancing.toString()];
		if(this.endImportFinancing)this.paginationRequest.filters["endFinancingImportFinancing"] = [this.endImportFinancing.toString()];
		if(this.startTotalImport)this.paginationRequest.filters["startFinancingTotalImport"] = [this.startTotalImport.toString()];
		if(this.endTotalImport)this.paginationRequest.filters["endFinancingTotalImport"] = [this.endTotalImport.toString()];
	}

	public createVehicle(): void {
		console.log("[VEHICLE-TABLE] createVehicle *** ");
		this.selectedVehicle = null;
		this.isNew = false;
		this.invVehicleService.startedCreating.next();
	}

	public editVehicle(vehicle: Rest.Vehicle): void {
		console.log("[VEHICLE-TABLE] editVehicle *** ");
		console.log(vehicle);
		if (!this.isFormGranted) {
			// If not granted, simply return without doing anything,
			// effectively disabling the functionality.
			return;
		}
		this.selectedVehicle = vehicle;
		this.isNew = false;
		this.invVehicleService.startedEditing.next(this.selectedVehicle);
	}

	setPermissions() {
		// console.log("[VEHICLE-FORM] setPermissions *** ");
		const user = this.authenticationService.user;
		const rolesForForm = ['VEHICLES_READ', 'VEHICLES_UPDATE'];

		this.isCreateGranted = this.authenticationService.isRoleGranted('VEHICLES_CREATE', user);
		this.isFormGranted = this.authenticationService.isOneRoleGranted(rolesForForm, user);

		this.isVehicleStateGranted = this.authenticationService.isRoleGranted('INV_VEHICLE_STATE_READ', user);
		this.isCostGranted = this.authenticationService.isRoleGranted('INV_FINANCING_COSTS_READ', user);
		this.isExtraGranted = this.authenticationService.isRoleGranted('INV_FINANCING_EXTRA', user);

		// console.log("this.isCreateGranted: " + this.isCreateGranted);
		// console.log("this.isFormGranted: " + this.isFormGranted);
	}

	setColumns() {
		let headerValue = '';
		this.columns = [];
		this.columns.push({
						field: 'name',
						header: this.translateService.instant('control-panel.vehicles.licensePlate'),
						type: 'string',
						excel: true,
						required: true,
						bindField: (entity: any) => entity.name ?? ''
					});
		this.columns.push({
			field: 'model?.brand?.name',
			header: this.translateService.instant('tableManagement.brands.brand'),
			type: 'string',
			excel: true,
			bindField: (entity: any) => entity.model?.brand?.name ?? ''
		});
		this.columns.push({
			field: 'model?.name',
			header: this.translateService.instant('tableManagement.models.model'),
			type: 'string',
			excel: true,
			bindField: (entity: any) => entity.model?.name ?? ''
		});
		this.columns.push({
			field: 'version?.name',
			header: this.translateService.instant('tableManagement.versions.version'),
			type: 'string',
			excel: true,
			bindField:(entity: any) => entity.version?.name ?? ''
		});
		this.columns.push({
			field: 'frameNumber',
			header: this.translateService.instant('control-panel.vehicles.frameNumber'),
			type: 'string',
			excel: true,
			bindField: (entity: any) => entity.frameNumber ?? ''
		});
		this.columns.push({
			field: 'status?.name',
			header: this.translateService.instant('tableManagement.vehicleStatus.vehicleStatus'),
			type: 'string',
			excel: true,
			bindField: (entity: any) => entity.status?.name ?? ''
		});
		this.columns.push({
			field: 'driver?.employee.code',
			header: this.translateService.instant('drivers.driverCode'),
			type: 'string',
			excel: true,
			bindField: (entity: any) => entity.driver?.employee.code ?? ''
		});
		this.columns.push({
			field: 'driver?.employee.user.name',
			header: this.translateService.instant('drivers.driverName'),
			type: 'string',
			excel: true,
			bindField: (entity: any) => entity.driver?.employee.user.surname1 + " " + entity.driver?.employee.user.surname2 + ", " + entity.driver?.employee.user.name
		});
		this.columns.push({
			field: 'billingAccount?.code',
			header: this.translateService.instant('general.code'),
			type: 'string',
			excel: true,
			bindField:  (entity: any) => entity.billingAccount?.code ?? ''
		});
		this.columns.push({
			field: 'billingAccount?.name',
			header: this.translateService.instant('tableManagement.companies.company'),
			type: 'string',
			excel: true,
			bindField: (entity: any) => entity.billingAccount?.name ?? ''
		});
		this.columns.push({
			field: 'delegation?.code',
			header: this.translateService.instant('general.code') + " " + this.translateService.instant('tableManagement.delegations.delegation'),
			type: 'string',
			excel: true,
			bindField: (entity: any) => entity.delegation?.code ?? ''
		});
		this.columns.push({
			field: 'delegation?.name',
			header: this.translateService.instant('tableManagement.delegations.delegation'),
			type: 'string',
			excel: true,
			bindField: (entity: any) => entity.delegation?.name ?? ''
		});
		this.columns.push({
			field: 'ceco?.code',
			header: this.translateService.instant('general.code') + " " + this.translateService.instant('drivers.table.ceco'),
			type: 'string',
			excel: true,
			bindField: (entity: any) => entity.ceco?.code ?? ''
		});
		this.columns.push({
			field: 'ceco?.description',
			header: this.translateService.instant('drivers.table.ceco') ,
			type: 'string',
			excel: true,
			bindField: (entity: any) => entity.ceco?.description ?? ''
		});


		this.columns.push({
			field: 'financing?.financingType?.name',
			header: this.translateService.instant('tableManagement.financing.financingType'),
			type: 'string',
			excel: true,
			bindField: (entity: any) => (entity.renting ? this.translateService.instant('tableManagement.financing.renting'): this.translateService.instant('tableManagement.financing.own')),
		});



		this.columns.push({
			field: 'financing?.provider?.name',
			header: this.translateService.instant('tableManagement.financing.financing'),
			type: 'string',
			excel: true,
			bindField: (entity: any) => (entity.financing ? entity.financing?.provider?.name: entity.renting ? '': this.translateService.instant('tableManagement.financing.own'))
		});
		const financingStartDate = (entity: any) => {
			const datestring= entity.financing?.startDate  ?? '';
			 if (datestring !='')
		 {
				const date = new Date(datestring);
				if (!isNaN(date.getTime())) {
					//const date = new Date(datestring);
					date.setHours(0, 0, 0, 0); // Forzar las horas a 00:00:00 en la zona local
					return date;
				}
			}
			return null;
	   };
	   this.columns.push({
			field: 'financing?.startDate',
			header: this.translateService.instant('tableManagement.financing.start'),
			type: 'date',
			excel: true,
			bindField: financingStartDate,
			excelType: 'd',
			excelFormat: 'dd/mm/yyyy',
		});
		const financingEndDate = (entity: any) => {
			const datestring= entity.financing?.endDate  ?? '';
			 if (datestring !='')
		 {
				const date = new Date(datestring);
				if (!isNaN(date.getTime())) {
				 date.setHours(0, 0, 0, 0); // Forzar las horas a 00:00:00 en la zona local
				 return date;
				}
			}	
			return null;
	   };
	   this.columns.push({
			field: 'financing?.endDate',
			header: this.translateService.instant('tableManagement.financing.end'),
			type: 'date',
			excel: true,
			bindField: financingEndDate,
			excelType: 'd',
			excelFormat: 'dd/mm/yyyy',
		});
		const financingCancellationDate = (entity: any) => {
			const datestring= entity.financing?.cancellationDate  ?? '';
			 if (datestring !='')
		 {
				const date = new Date(datestring);
				if (!isNaN(date.getTime())) {
				 date.setHours(0, 0, 0, 0); // Forzar las horas a 00:00:00 en la zona local
				 return date;
				}
			}
			return null;
	   };
	   this.columns.push({
			field: 'financing?.cancellationDate',
			header: this.translateService.instant('tableManagement.financing.cancelationDate'),
			type: 'date',
			excel: true,
			bindField: financingCancellationDate,
			excelType: 'd',
			excelFormat: 'dd/mm/yyyy',
		});
		if (this.isExtraGranted) {
			this.columns.push({
				field: 'financing?.importService',
				header: this.translateService.instant('tableManagement.financing.importService'),
				type: 'number',
				excel: true,
				excelType: 'n',
				bindField: (entity: any) => entity.financing?.importService ?? '',
			});
			this.columns.push({
				field: 'financing?.importFinancing',
				header: this.translateService.instant('tableManagement.financing.importFinancing'),
				type: 'number',
				excel: true,
				excelType: 'n',
				bindField: (entity: any) => entity.financing?.importFinancing ?? '',
			});
			this.columns.push({
				field: 'financing?.totalImport',
				header: this.translateService.instant('tableManagement.financing.totalImport'),
				type: 'number',
				excel: true,
				excelType: 'n',
				bindField: (entity: any) => entity.financing?.totalImport ?? '',
			});
		}
		this.columns.push({
			field: 'financing?.monthlyFee',
			header: this.translateService.instant(this.isExtraGranted ? 'tableManagement.financing.totalPlusVat' : 'tableManagement.financing.monthlyFee'),
			type: 'number',
			excel: true,
			excelType: 'n',
			bindField: (entity: any) => entity.financing?.monthlyFee ?? '',
		});
		this.columns.push({
				field: 'vehicleAssignments[0].iva',
				header: this.translateService.instant('tableManagement.financing.vat'),
				type: 'number',
				excel: true,
				excelType: 'n',
				bindField: (entity: any) => entity.vehicleAssignments.length > 0 ? Number(entity.vehicleAssignments[0].iva.substring(1)) : ''
		});
		const startDateCreated = (entity: any) => {
			const datestring= entity.dateRegistered ?? '';
			 if (datestring !='')
		 {
				const date = new Date(datestring);
				if (!isNaN(date.getTime())) {
				 date.setHours(0, 0, 0, 0); // Forzar las horas a 00:00:00 en la zona local
				 return date;
				}
			}
			return null;
	   };
	   this.columns.push({
			field: 'dateRegistered',
			header: this.translateService.instant('tableManagement.createDate'),
			type: 'date',
			excel: true,
			bindField: startDateCreated,
			excelType: 'd',
			excelFormat: 'dd/mm/yyyy',
		});
		const disabledDate = (entity: any) => {
			const datestring= entity.disabledDate ?? '';
			 if (datestring !='')
		 {
				const date = new Date(datestring);
				if (!isNaN(date.getTime())) {
				 date.setHours(0, 0, 0, 0); // Forzar las horas a 00:00:00 en la zona local
				 return date;
				}
			}
			return null;
	   };
	   this.columns.push({
			field: 'disabledDate',
			header: this.translateService.instant('tableManagement.disabledDate'),
			type: 'date',
			excel: true,
			bindField: disabledDate,
			excelType: 'd',
			excelFormat: 'dd/mm/yyyy',
		});
 		this.columns.push({
			field: 'enabled',
			header: this.translateService.instant('general.active'),
			type: 'boolean',
			excel: true,
			excelType: 'b',
			bindField: (entity: any) => entity.enabled ?? '',
		});

		this.columnsCount = this.columns.length;
		this.selectedColumns = this.columns;
		super.mapSelectedColumns();
	}

	excelColumns = {};
	exportExcel() {
	//	this.setExcelColumns();
		let fileNameTitle = this.translateService.instant('tableManagement.vehicle.vehiclesManagement');
	//super.exportExcelWithColumns(fileNameTitle, this.excelColumns);
		super.exportExcelWithColumnsMetadata(fileNameTitle, this.selectedColumns);
	}

	//setExcelColumns() {
		// const name = (entity: any) => entity.name ?? ''
		// const brand = (entity: any) => entity.model?.brand?.name ?? ''
		// const model = (entity: any) => entity.model?.name ?? ''
		// const version = (entity: any) => entity.version?.name ?? ''
		// const frameNumber = (entity: any) => entity.frameNumber ?? ''
		// const vehicleStatus = (entity: any) => entity.status?.name ?? ''
		// const driverCode = (entity: any) => entity.driver?.employee.code ?? ''
		// const driverName = (entity: any) => entity.driver?.employee.user.surname1 + " " + entity.driver?.employee.user.surname2 + "" + entity.driver?.employee.user.name
		// const billingAccountCode = (entity: any) => entity.billingAccount?.code ?? ''
		// const billingAccountName = (entity: any) => entity.billingAccount?.name ?? ''
		// const delegationCode = (entity: any) => entity.delegation?.code ?? ''
		// const delegationName = (entity: any) => entity.delegation?.name ?? ''
		// const cecoCode = (entity: any) => entity.ceco?.code ?? ''
		// const cecoDescription = (entity: any) => entity.ceco?.description ?? ''
		// const financingType = (entity: any) => entity.financing?.financingType?.name ?? ''
		// const providerName = (entity: any) => entity.financing?.provider?.name ?? ''
	 	// const financingStartDate = (entity: any) => {
	 	// 	const datestring= entity.financing?.startDate  ?? '';
	 	//  	if (datestring !='')
 		//  {
	 	// 		const date = new Date(datestring);
	 	//  		date.setHours(0, 0, 0, 0); // Forzar las horas a 00:00:00 en la zona local
	 	//  		return date;
	 	// 	}
	 	//  	else
	 	//  	{
	 	// 		return '';
	 	//  	}
		// };
		// const financingEndDate = (entity: any) => {
	 	// 	const datestring= entity.financing?.endDate  ?? '';
	 	// 	if (datestring !='')
 		// {
	 	// 		const date = new Date(datestring);
	 	// 		date.setHours(0, 0, 0, 0); // Forzar las horas a 00:00:00 en la zona local
	 	// 		return date;
	 	// 	}
	 	// 	else
	 	// 	{
	 	// 		return '';
	 	// 	}
		// };
		// const financingCancellationDate = (entity: any) => {
	 	// 	const datestring= entity.financing?.cancellationDate  ?? '';
	 	// 	if (datestring !='')
 		// {
	 	// 		const date = new Date(datestring);
	 	// 		date.setHours(0, 0, 0, 0); // Forzar las horas a 00:00:00 en la zona local
	 	// 		return date;
	 	// 	}
	 	// 	else
	 	// 	{
	 	// 		return '';
	 	// 	}
		// };

		// const financingMonthlyFee = (entity: any) => entity.financing?.monthlyFee ?? ''
		// const iva = (entity: any) => entity.vehicleAssignments.length > 0 ? Number(entity.vehicleAssignments[0].iva.substring(1)) : ''
		// const startDateCreated = (entity: any) => entity.dateRegistered ?? ''
		// const disabledDate = (entity: any) => entity.disabledDate ?? ''
		// const enabled = (entity: any) => entity.enabled ?? ''


		// this.excelColumns = {
			// [this.translateService.instant('control-panel.vehicles.licensePlate')]: { bindField: name},
			// [this.translateService.instant('tableManagement.brands.brand')]: { bindField: brand },
			// [this.translateService.instant('tableManagement.models.model')]: { bindField: model },
			// [this.translateService.instant('tableManagement.versions.version')]: { bindField: version },
			// [this.translateService.instant('control-panel.vehicles.frameNumber')]: { bindField: frameNumber },
			// [this.translateService.instant('tableManagement.vehicleStatus.vehicleStatus')]: { bindField: vehicleStatus },
			// [this.translateService.instant('drivers.driverCode')]: { bindField: driverCode },
			// [this.translateService.instant('drivers.driverName')]: { bindField: driverName },
			// [this.translateService.instant('general.code')]: { bindField: billingAccountCode },
			// [this.translateService.instant('tableManagement.companies.company')]: { bindField: billingAccountName },
			// [this.translateService.instant('general.code') + " " + this.translateService.instant('tableManagement.delegations.delegation')]: { bindField: delegationCode },
			// [this.translateService.instant('tableManagement.delegations.delegation')]: { bindField: delegationName },
			// [this.translateService.instant('general.code') + " " + this.translateService.instant('drivers.table.ceco')]: { bindField: cecoCode },
			// [this.translateService.instant('drivers.table.ceco')]: { bindField: cecoDescription },
			// [this.translateService.instant('tableManagement.financing.financingType')]: { bindField: financingType },
			// [this.translateService.instant('tableManagement.financing.financing')]: { bindField: providerName },
			// [this.translateService.instant('tableManagement.financing.start')]: { bindField:financingStartDate,	excelType: 'd', excelFormat: 'dd/mm/yyyy'},
			//  [this.translateService.instant('tableManagement.financing.end')]: { bindField: financingEndDate },
			// [this.translateService.instant('tableManagement.financing.cancelationDate')]: { bindField: financingCancellationDate },
			// [this.translateService.instant('tableManagement.financing.monthlyFee')]: { bindField: financingMonthlyFee },
			// [this.translateService.instant('tableManagement.financing.vat')]: { bindField: iva },
			// [this.translateService.instant('tableManagement.createDate')]: { bindField: startDateCreated },
			// [this.translateService.instant('tableManagement.disabledDate')]: { bindField: disabledDate },
			// [this.translateService.instant('general.active')]: { bindField: enabled }


		//}

		// [this.translateService.instant('tableManagement.financing.start')]: { bindField: financingStartDate },
	//}


	public getBrandsByClient(clientId: number) {
		const promise = new Promise<void>((resolve, reject) => {
			const that = this;
			this.invVehicleService
				.getBrands(clientId)
				.then(
					function (response) {
						that.brandList = response;
						that.brandList.sort((a, b) => a.name > b.name ? 1 : -1);
						that.combos.push({field:"brand", values: that.brandList});
					},
					/* failure */
					function (error) {
						console.log('The request failed: ' + error);
						resolve();
					}
				)
				.catch(function (reason) {
					console.log('Catched: ' + reason);
					resolve();
				});
		});
	}

	public getModelsByClient(clientId: number) {
		const promise = new Promise<void>((resolve, reject) => {
			const that = this;
			this.invVehicleService.getModelsByClient(clientId)
				.then(
					function (response) {
						that.modelList = response;
						that.modelList.sort((a, b) => a.name > b.name ? 1 : -1);
						that.combos.push({field:"model", values: that.modelList});
					},
					/* failure */
					function (error) {
						console.log('The request failed: ' + error);
						resolve();
					},
				)
				.catch(function (reason) {
					console.log('Catched: ' + reason);
					resolve();
				});
		});
	}

	public getVersionsByClient(clientId: number) {
		const promise = new Promise<void>((resolve, reject) => {
			const that = this;
			this.invVehicleService.getVersionsByClient(clientId)
				.then(
					function (response) {
						that.versionList = response;
						that.versionList.sort((a, b) => a.name > b.name ? 1 : -1);
						that.combos.push({field:"version", values: that.versionList});
					},
					/* failure */
					function (error) {
						console.log('The request failed: ' + error);
						resolve();
					},
				)
				.catch(function (reason) {
					console.log('Catched: ' + reason);
					resolve();
				});
		});
	}

	public getVehicleTypes() {
		const promise = new Promise<void>((resolve, reject) => {
			const that = this;
			this.invVehicleService.getVehicleTypes()
				.then(
					function (response) {
						that.vehicleTypeList = response;
						that.vehicleTypeList.sort((a, b) => a.name > b.name ? 1 : -1);
						// that.combos.push({field:"model", values: that.vehicleTypeList});
					},
					/* failure */
					function (error) {
						console.log('The request failed: ' + error);
						resolve();
					},
				)
				.catch(function (reason) {
					console.log('Catched: ' + reason);
					resolve();
				});
		});
	}

	public getVehicleStatus(clientId: number) {
		const promise = new Promise<void>((resolve, reject) => {
			const that = this;
			this.invVehicleService.getVehicleStatus(clientId)
				.then(
					function (response) {
						that.vehicleStatusList = response;
						that.vehicleStatusList.sort((a, b) => a.name > b.name ? 1 : -1);
						that.combos.push({field:"status", values: that.vehicleStatusList});
					},
					/* failure */
					function (error) {
						console.log('The request failed: ' + error);
						resolve();
					},
				)
				.catch(function (reason) {
					console.log('Catched: ' + reason);
					resolve();
				});
		});
	}

	public getDrivers(clientId: number) {
		const promise = new Promise<void>((resolve, reject) => {
			const that = this;
			this.driverService.getList(clientId)
				.then(
					function (response) {
						that.driversList = response;
						that.driversList.sort((a, b) => a.driverAssignments[0]?.driver.employee?.user.name > b.driverAssignments[0]?.driver.employee?.user.name ? 1 : -1);

					},
					/* failure */
					function (error) {
						console.log('The request failed: ' + error);
						resolve();
					},
				)
				.catch(function (reason) {
					console.log('Catched: ' + reason);
					resolve();
				});
		});
	}

	public getCompanies(clientId: number) {
		const promise = new Promise<void>((resolve, reject) => {
			const that = this;
			this.invVehicleService.getBillingAccounts(clientId)
				.then(
					function (response) {
						that.companiesList = response;
						that.companiesList.sort((a, b) => a.name > b.name ? 1 : -1);
						that.combos.push({field:"billingAccount", values: that.companiesList});
					},
					/* failure */
					function (error) {
						console.log('The request failed: ' + error);
						resolve();
					},
				)
				.catch(function (reason) {
					console.log('Catched: ' + reason);
					resolve();
				});
		});
	}

	public getDelegationList(clientId: number) {
		const promise = new Promise<void>((resolve, reject) => {
			const that = this;
			this.delegationService
				.getList(clientId)
				.then(
					function (response) {
						that.delegationList = response;
						that.delegationList.sort((a, b) => a.name > b.name ? 1 : -1);
						that.combos.push({field:"delegation", values: that.delegationList});
					},
					/* failure */
					function (error) {
						console.log('The request failed: ' + error);
						resolve();
					},
				)
				.catch(function (reason) {
					console.log('Catched: ' + reason);
					resolve();
				});
		});
	}

	public getSubdelegationList(clientId: number) {
		const promise = new Promise<void>((resolve, reject) => {
			const that = this;
			this.subdelegationService
				.getListByClient(clientId)
				.then(
					function (response) {
						that.subdelegationList = response;

					},
					/* failure */
					function (error) {
						console.log('The request failed: ' + error);
						resolve();
					},
				)
				.catch(function (reason) {
					console.log('Catched: ' + reason);
					resolve();
				});
		});
	}


	getCecoList() {
		let cecoFilterRequest = {
			sortBy: null,
			sortAsc: true,
			pageSize: 2147483647,
			filters: {},
			loadPermissions: false
			//offset: event.first // número de pàgina (lazyload)
			//pageSize: event.rows // número de files (lazyload)
		} as unknown as Rest.ListPaginationRequest;
		const promise = new Promise<void>((resolve, reject) => {
			const that = this;
			this.cecoService.getPage(cecoFilterRequest)
				.then(
					function (response) {
						that.cecoList = response.entities;
						that.combos.push({field:"ceco", values: that.cecoList});
					},
					/* failure */
					function (error) {
						console.log('The request failed: ' + error);
						resolve();
					},
				)
				.catch(function (reason) {
					console.log('Catched: ' + reason);
					resolve();
				});
		});
	}

	getFinancingTypeList() {
		this.financingTypeList = [
			{ id: 1, name: this.translateService.instant('tableManagement.financing.renting'), value: true },
			{ id: 2, name: this.translateService.instant('tableManagement.financing.own'), value: false }
		]
	}

	onFilterApplied(event?: any) {
		this.filteredColumns = Object.entries(this.vehicleTableFilters)
		  .filter(([field, filter]) => filter && filter[0].value !== undefined && filter[0].value !== null) // Solo filtros activos
		  .map(([field, filter]) => {
			const translationMap: { [key: string]: string } = { 
				name: 'control-panel.vehicles.licensePlate', 
				brand:'tableManagement.brands.brand',
				model:'tableManagement.models.model',
				version:'tableManagement.versions.version',
				frameNumber:'control-panel.vehicles.frameNumber',
				status:'tableManagement.vehicleStatus.vehicleStatus',
				driverCode:'drivers.driverCode',
				driverName:'drivers.driverName',
				billingAccount:'tableManagement.companies.company',
				delegation:'tableManagement.delegations.delegation',
				ceco:'drivers.table.ceco',
				renting:'tableManagement.vehicle.renting',
				financingProvider:'tableManagement.financing.financing',
				financingMonthlyFee:'tableManagement.financing.monthlyFee',
				dateRegistered:'tableManagement.createDate',
				disabledDate:'tableManagement.disabledDate',
				enabled: 'general.active',
				financingStartDate: 'tableManagement.financing.start',
				financingEndDate: 'tableManagement.financing.end'

			}; 
			return{				
			field,
			value: filter[0].value,
			valueid: filter[0].value,
			fieldtrans: this.translateService.instant(translationMap[field] || 'default.translation.key'),
		  };});
		  if ((this.startDateCreated) || (this.endDateCreated))
		  {
				 if ((this.startDateCreated) && (this.endDateCreated))
				 {
					let datelabel = this.formatDate(this.startDateCreated) + " - " + this.formatDate(this.endDateCreated);
					this.filteredColumns.push({field: "dateRegistered", valueid: datelabel, value: datelabel,fieldtrans: this.translateService.instant('tableManagement.createDate') })
				 }
				 else if (this.startDateCreated)
				 {
					let datelabel = this.formatDate(this.startDateCreated);
					this.filteredColumns.push({field: "dateRegistered", valueid: datelabel, value: datelabel,fieldtrans: this.translateService.instant('tableManagement.createDate') })

				 }
				 else if (this.endDateCreated)
				{
					let datelabel = this.formatDate(this.endDateCreated);
					this.filteredColumns.push({field: "dateRegistered", valueid: datelabel, value: datelabel,fieldtrans: this.translateService.instant('tableManagement.createDate') })
				}	
		}
		if ((this.startDateDisabled) || (this.endDateDisabled))
		{
			if ((this.startDateDisabled) && (this.endDateDisabled))
			{
			  let datelabel = this.formatDate(this.startDateDisabled) + " - " + this.formatDate(this.endDateDisabled);
			  this.filteredColumns.push({field: "disabledDate", valueid: datelabel, value: datelabel,fieldtrans: this.translateService.instant('tableManagement.disabledDate') })
			}
			else if  (this.startDateDisabled)
			{
				let datelabel = this.formatDate(this.startDateDisabled);
				this.filteredColumns.push({field: "disabledDate", valueid: datelabel, value: datelabel,fieldtrans: this.translateService.instant('tableManagement.disabledDate') })
			}
			else if  (this.endDateDisabled)
			{
				let datelabel = this.formatDate(this.endDateDisabled);
				this.filteredColumns.push({field: "disabledDate", valueid: datelabel, value: datelabel,fieldtrans: this.translateService.instant('tableManagement.disabledDate') })
					  
			}
		}
		
		if((this.startFinancingStartDate) || (this.endFinancingStartDate)){
			if ((this.startFinancingStartDate) && (this.endFinancingStartDate))
			{
			  let datelabel = this.formatDate(this.startFinancingStartDate) + " - " + this.formatDate(this.endFinancingStartDate);
			  this.filteredColumns.push({field: "financingStartDate", valueid: datelabel, value: datelabel,fieldtrans: this.translateService.instant('tableManagement.financing.start') })
			}
			else if  (this.startFinancingStartDate)
			{
				let datelabel = this.formatDate(this.startFinancingStartDate);
				this.filteredColumns.push({field: "financingStartDate", valueid: datelabel, value: datelabel,fieldtrans: this.translateService.instant('tableManagement.financing.start') })
			}
			else if  (this.endFinancingStartDate)
			{
				let datelabel = this.formatDate(this.endFinancingStartDate);
				this.filteredColumns.push({field: "financingStartDate", valueid: datelabel, value: datelabel,fieldtrans: this.translateService.instant('tableManagement.financing.start') })
					  
			}
		}

		if((this.startFinancingEndDate) || (this.endFinancingEndDate)){
			if ((this.startFinancingEndDate) && (this.endFinancingEndDate))
			{
			  let datelabel = this.formatDate(this.startFinancingEndDate) + " - " + this.formatDate(this.endFinancingEndDate);
			  this.filteredColumns.push({field: "financingEndDate", valueid: datelabel, value: datelabel,fieldtrans: this.translateService.instant('tableManagement.financing.end') })
			}
			else if  (this.startFinancingEndDate)
			{
				let datelabel = this.formatDate(this.startFinancingEndDate);
				this.filteredColumns.push({field: "financingEndDate", valueid: datelabel, value: datelabel,fieldtrans: this.translateService.instant('tableManagement.financing.end') })
			}
			else if  (this.endFinancingEndDate)
			{
				let datelabel = this.formatDate(this.endFinancingEndDate);
				this.filteredColumns.push({field: "financingEndDate", valueid: datelabel, value: datelabel,fieldtrans: this.translateService.instant('tableManagement.financing.end') })
					  
			}
		}
	  }
	
	  // Limpia el filtro de una columna específica
	  clearFilter(field: string) {
		if (this.vehicleTableFilters[field]) {
		  delete this.vehicleTableFilters[field]; // Elimina el filtro
		}
		// Notifica a la tabla que los filtros han cambiado
		if (field =="dateRegistered")
		{
			if ((this.startDateCreated) || (this.endDateCreated))
			{
				this.startDateCreated = null;
				this.endDateCreated=null;
			}
		}
		if (field =="disabledDate")
		{
			if ((this.startDateDisabled) || (this.endDateDisabled))
			{
				this.startDateDisabled = null;
				this.endDateDisabled=null;
			}
		}

		if(field == "financingStartDate"){
			if((this.startFinancingStartDate) || (this.endFinancingStartDate)){
				this.startFinancingStartDate = null;
				this.endFinancingStartDate=null;
			}
		}

		if(field == "financingEndDate"){
			if((this.startFinancingEndDate) || (this.endFinancingEndDate)){
				this.startFinancingEndDate = null;
				this.endFinancingEndDate=null;
			}
		}

		this.filteredColumns = this.filteredColumns.filter(col => col.field !== field);
		 // Reinicia el filtro visualmente
		 const filter = this.columnFilters.find(f => f.field === field);
		 if (filter) {
		   filter.clearFilter();
		 }

	  }

	  reloadTable(): void {
		const lazyEvent = {
		  first: 0,
		  rows: this.paginationRequest.pageSize,
		  sortField: 'name',
		  sortOrder: 1,
		  filters: this.vehicleTableFilters,

		};
	
		this.loadData(lazyEvent);
	  }

	  formatValue(field:string, value:any)
	  {
		const combo = this.combos.find(c => c.field === field);
		if (combo) {
			if (Array.isArray(value)) {
				// Si value es un array, mapea cada ID al valor correspondiente
				return value.map(val => {
				  const item = combo.values.find(v => v.id.toString().trim() === val.toString().trim());
				  if (field =="ceco")
				 {
				  return item ? item.code : val;
				 }
				 else
				 {
					return item ? item.name : val;
				 }
				}).join(', ');
			  } else {
				// Si value no es un array, maneja como antes
				const item = combo.values.find(v => v.id.toString().trim() === value.toString().trim());
				return item ? item.name : value;
			  }
		}
		 if (field === 'dateRegistered') {
			// if (field === 'dateRegistered'  && Array.isArray(value)) {
		// 	// Si el filtro es un rango de fechas, formatea las dos fechas
		// 	const startDate = value.find(v => v.matchMode === 'gte')?.value;
		// 	const endDate = value.find(v => v.matchMode === 'lte')?.value;
		
		// 	if (startDate && endDate) {
		// 	  return `${this.formatDate(startDate)} - ${this.formatDate(endDate)}`;
		// 	}
		   }
		 // Manejo de campos booleanos
		 if (typeof value === 'boolean') {
			return value ? this.translateService.instant('general.yes') : this.translateService.instant('general.no');
		  }
		  // Manejo de campos de fecha
		  if (field === 'dateField') {
			const date = new Date(value);
			return date.toLocaleDateString();
		  }
		
		  // Manejo de otros tipos de campos (strings, números, etc.)
		  return value.toString();
	  }
	  	//POR AHORA NO PONEMOS LIMPIAR TODOS PORQUE NO VA BIEN AUNQUE HAGA LO MISMO QUE UNO A UNO.
	   clearAllFilters(): void {
			this.filteredColumns.forEach(element => {
				if (this.vehicleTableFilters[element.field]) {
					delete this.vehicleTableFilters[element.field]; // Elimina el filtro
				  }
				if ((this.startDateCreated) || (this.endDateCreated))
				{
					this.startDateCreated = null;
					this.endDateCreated=null;
				}
				if ((this.startDateDisabled) || (this.endDateDisabled))
				{
					this.startDateDisabled = null;
					this.endDateDisabled=null;
				}
				const filter = this.columnFilters.find(f => f.field === element.field);
				if (filter) {
				filter.clearFilter();
				}
			});

			
			// this.vehicleTableFilters = {}; 
			// this.onFilterApplied(); 
	   }
	//    onDateFilterChange(type:number):void{
	// 		const dateFilter = [];
	// 		if (this.startDateCreated) {
	// 			if (dateFilter.find(element=> element.matchMode=='gte')) delete dateFilter['gte']; 
	// 			dateFilter.push({ matchMode: 'gte', value: this.formatDate(this.startDateCreated) });
	// 		}

	// 		if (this.endDateCreated) {
	// 			if (dateFilter.find(element=> element.matchMode=='lte'))  delete dateFilter['lte']; 
	// 				dateFilter.push({ matchMode: 'lte', value: this.formatDate(this.endDateCreated) });
	// 		}
	// 		if (dateFilter.length > 1) {
	// 			this.vehicleTableFilters['dateRegistered'] = dateFilter;
	// 		}
	// 		//  else {
	// 		// 	delete this.vehicleTableFilters['dateRegistered']; // Limpia el filtro si no hay fechas seleccionadas
	// 		// }
  	// 	}

		// Formatea la fecha al formato 'yyyy-MM-dd'
		// formatDate(date: Date): string {
		// 	const year = date.getFullYear();
		// 	const month = (date.getMonth() + 1).toString().padStart(2, '0');
		// 	const day = date.getDate().toString().padStart(2, '0');
		// 	return `${year}-${month}-${day}`;
		// }
		formatDate(date: Date): string {
			// Puedes personalizar este formato según tu necesidad
			//const d = new Date(date);
			const d = date;
			const day = d.getDate().toString().padStart(2, '0');
			const month = (d.getMonth() + 1).toString().padStart(2, '0');
			const year = d.getFullYear();
			return `${day}/${month}/${year}`;
		  }
}

